import { create, tsx } from '@dojo/framework/core/vdom';
import { RenderResult } from '@dojo/framework/core/interfaces';
import * as css from './ColumnSummary.m.css';
import { Text } from './Text';
import Summary from './Summary';

export interface ColumnSummaryProperties {
	/** default=3 */
	columnCount?: 2 | 4 | 5;
	/** Apply fade in transition to the items in the column summary */
	animate?: boolean;
}

export interface ColumnSummaryItem {
	image: RenderResult;
	title: RenderResult;
	blurb: RenderResult;
}

export interface ColumnSummaryChildren {
	title: RenderResult;
	blurb?: RenderResult;
	items: ColumnSummaryItem[];
}

const factory = create().properties<ColumnSummaryProperties>().children<ColumnSummaryChildren>();

export const ColumnSummary = factory(function ColumnSummary({ children, properties }) {
	const { animate, columnCount } = properties();
	const [{ title, blurb, items }] = children();

	const summaries = items.map((item) => (
		<div>
			<Summary smaller stack animate={animate}>
				{{
					...item
				}}
			</Summary>
		</div>
	));

	return (
		<virtual>
			<div classes={[css.headerContainer]}>
				<Text type="section">{title}</Text>
				{blurb && <Text type="body">{blurb}</Text>}
			</div>
			<div
				classes={[
					css.grid,
					columnCount === 2 && css.twoColumns,
					columnCount === 4 && css.fourColumns,
					columnCount === 5 && css.fiveColumns,
					animate && 'fade-section'
				]}
			>
				{summaries}
			</div>
		</virtual>
	);
});

export default ColumnSummary;
